export default {"src":"/_next/static/media/CECA_ICONOS_Hogar-SillonTV-18.8ab227ab.svg","height":160,"width":361,"blurWidth":0,"blurHeight":0};